import { getQuery, getLimitOptions } from 'utilities/query';
import templateUrl from './maintenance-admin-list.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administrations: '<',
    selectedAdministrations: '<',
    units: '<',
    unitsDisplay: '<',
    unitPerContainer: '<',
    locked: '<',
    showHeader: '<'
  },
  controller: class MaintenanceAdminListComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      this.query = getQuery();
      this.limitOptions = getLimitOptions();
      this.administrations = this.administrations.filter(a => a.Isloading === false);
    }

    $onChanges() {
      this.administrations = this.administrations.filter(a => a.Isloading === false);
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/maintenance-admin-list/maintenance-admin-list.component.js